'use client'

import { ICurrency } from '@/api/cities/types/cities-types'
import { GetCityRestaurantResponseData } from '@/api/restaurants/types/restaurant-types'
import { RestaurantCard } from '@/features/restaurants/restaurant-card/restaurant-card'
import { RestaurantCardsProvider } from '@/features/restaurants/restaurant-card/restaurant-cards-context'
import { SEARCH_RESULTS_CLASS_NAME } from '@/features/restaurants/restaurants-city-search/restaurant-city-search-results'

interface ICityBrandRestaurantsProps {
    citySlug: string
    restaurants: GetCityRestaurantResponseData
    currency: ICurrency | undefined
}

export const CityBrandRestaurants = ({
    citySlug,
    restaurants,
    currency,
}: ICityBrandRestaurantsProps) => {
    return (
        <div className={SEARCH_RESULTS_CLASS_NAME}>
            <RestaurantCardsProvider styleType="default">
                {restaurants.map((restaurant, index) => (
                    <RestaurantCard
                        index={index}
                        loadWithPriority={index < 3}
                        citySlug={citySlug}
                        key={restaurant.uuid}
                        restaurant={restaurant}
                        currency={currency}
                    />
                ))}
            </RestaurantCardsProvider>
        </div>
    )
}
